import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { logOutUser } from "../../redux/auth/sessions/actions";
import { displayModal } from "../../redux/ui/main/actions";

import Modal from "react-modal";
import ModalBody from "../modals/ModalBody";
import { Button } from "../shared/Button";

const LogOutErrorModal = () => {
  const showModal = useSelector(state => state.ui.main.modals.logoutErrorModal);
  const isLoading = useSelector(state => state.ui.main.loading.loggingOutLoading);
  const dispatch = useDispatch();

  return (
    <Modal
      isOpen={showModal}
      contentLabel="Logout Error Modal"
      ariaHideApp={false}
      className="Modal DefaultSize"
      onRequestClose={() => dispatch(displayModal("logoutError", false))}
    >
      <ModalBody>
        <div className="flex flex-col justify-center items-center">
          <span className="icon u-errorIcon mb-3"></span>
          <h2 className="text-lg mb-3 font-medium text-center text-gray-800">
            There was a problem logging you out
          </h2>
          <p className="text-sm text-center text-gray-410 leading-[1.4] mb-5">
            We encountered an error while attempting to log you out. Please try again.
            If this problem persists,{" "}
            <Link
              to="/support"
              className="text-blue-300 font-semibold hover:underline"
            >
              contact support
            </Link>
            .
          </p>
          <div className="FormButton-wrapper flex justify-center">
            <Button
              type="button"
              kind="secondary-gray"
              className="mr-3"
              onClick={() => dispatch(displayModal("logoutError", false))}
            >
              Cancel
            </Button>
            <Button
              type="button"
              kind="primary-purple"
              disabled={isLoading}
              onClick={() => dispatch(logOutUser)}
            >
              {isLoading ? "Logging out" : "Log out"}
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default LogOutErrorModal;
